module.exports = __webpack_public_path__ + "img/ar-top.96550559.jpg";